import styled from "styled-components";

export const ContactSection = styled.section`
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    padding: 1.5rem 0;

    h1{
        color: var(--dark--primary--text);
        font-size: 3rem;
    }

    form {
        display: flex;
        flex-direction: column;
        padding-top: 3rem;

        width: 90%;

        @media (min-width: 450px){
            width: 450px;
        }

        input{
            height: 3.5rem;
            color: var(--dark--primary--text);
        }

        label{
            color: var(--dark--primary--text);
            padding: 1rem 0;
        }

        textArea {
            height: 7rem;
            margin-bottom: 1.5rem;
            color: var(--dark--primary--text);
        }


    }

`